export const LANDING_CONTENT_WIDTH_PX = 1260

export const LANDING_CONTENT_PX = [6, 6, 7, 7, 9]

export const LANDING_BASIC_HEADER_PADDING_INLINE = 8

export const LANDING_SECTION_PY = [17, 17, 17, 17, 19]

export const LANDING_SECTION_GAP = [11, 11, 11, 11, 15]
